import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFormulaChangeGlyphSecondary from './svgs/FormulaChangeGlyphSecondary.js';
import SvgFormulaChangeGlyph from './svgs/FormulaChangeGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var formulaChangeGlyph = (props => useIcon(SvgFormulaChangeGlyph, SvgFormulaChangeGlyphSecondary, props));

export { formulaChangeGlyph as default };
